import classnames from 'classnames'
import {
  ListingSourceInfo,
  useComplianceData,
} from 'src/services/mlsComplianceDataService'
import styles from './MlsLogo.module.scss'

interface ListingProvidedByMlsNameProps {
  listing: ListingSourceInfo
  logoClassName?: string
  logoWrapperClassName?: string
}

export const MlsLogo = ({
  listing,
  logoClassName,
  logoWrapperClassName,
}: ListingProvidedByMlsNameProps) => {
  const complianceData = useComplianceData(listing)

  if (!complianceData?.displayLogo) {
    return null
  }

  return (
    <div className={classnames(styles.logoWrapper, logoWrapperClassName)}>
      <img
        className={classnames(styles.logoImg, logoClassName)}
        src={complianceData?.displayLogo}
        alt={`${complianceData?.mlsName} Logo`}
      />
    </div>
  )
}
